import { CountryCodeType } from './constants';
import {
  norwegianLicensePlateCarsAndTrucksRegex,
  norwegianLicensePlateOtherVehiclesRegex,
  partialNorwegianLicensePlateRegex,
  swedishLicensePlateRegex
} from './regex';

export const isValidLicensePlateNumber = ({
  input,
  countryCode
}: {
  input: string;
  countryCode: CountryCodeType;
}): boolean => {
  if (countryCode === 'NO') {
    return (
      input === '' ||
      partialNorwegianLicensePlateRegex.test(input) ||
      norwegianLicensePlateCarsAndTrucksRegex.test(input) ||
      norwegianLicensePlateOtherVehiclesRegex.test(input)
    );
  }
  return input === '' || swedishLicensePlateRegex.test(input);
};
